import { Layout } from "./layouts/Layout";

const App = ({ msalInstance }: { msalInstance: any }) => {
  return <Layout msalInstance={msalInstance} />;
};

export { App };
